import React, { createContext, useContext, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../reducers';

interface SelectModeContextType {
  selectMode: boolean;
  setSelectMode: (mode: boolean) => void;
}

const SelectModeContext = createContext<SelectModeContextType | undefined>(
  undefined
);

export const useSelectMode = () => {
  const context = useContext(SelectModeContext);
  if (context === undefined) {
    throw new Error('useSelectMode must be used within a SelectModeProvider');
  }
  return context;
};

interface SelectModeProviderProps {
  children: React.ReactNode;
}

export const SelectModeProvider: React.FC<SelectModeProviderProps> = ({
  children,
}) => {
  const { selectedFiles } = useSelector((state: RootState) => state.library);
  const showSelectedFileActions = Object.keys(selectedFiles).length > 0;
  const [selectMode, setSelectMode] = useState(showSelectedFileActions);

  // Auto-enter select mode when files are selected
  useEffect(() => {
    if (showSelectedFileActions && !selectMode) {
      setSelectMode(true);
    }
  }, [showSelectedFileActions, selectMode]);

  return (
    <SelectModeContext.Provider value={{ selectMode, setSelectMode }}>
      {children}
    </SelectModeContext.Provider>
  );
};
